import styled from 'styled-components';

export const DealPulseCardStyle = styled.div`
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding-left: 10px;
    background-color: #ffffff;
    font-size: 13px;
    margin-top: 10px;
`;

export const DealPulseHeaderStyle = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-weight: 600;
`;

export const DealPulseIconStyle = styled.div`
    margin-right: 6px;
`;

export const DealPulseTitleStyle = styled.span`
    color: #1a73e8;
`;

export const DealPulseRowStyle = styled.div`
    margin-bottom: 10px;
`;

export const DealPulseLabelStyle = styled.span`
    font-weight: 400;
`;

export const DealPulseValueStyle = styled.span`
    margin-top: 2px;
`;

export const DealPulseRangeStyle = styled.div`
    font-size: 12px;
    color: #6b7280;
    margin-top: 2px;
    gap: 4px;
`;

export const DealPulseLineStyle = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const DealPulseAnchorStyle = styled.div`
    font-size: 12px;
    color: #6b7280;
    margin-top: 8px;
`;

export const DealPulseInlineIconStyle = styled.span`
    display: inline-flex;
    vertical-align: middle;
    margin-left: 3px;
`;

export const DealPulseDividerStyle = styled.hr`
    border: none;
    border-top: 1px solid #b2b2b2;
    margin: 4px 10px 12px 0;
`;

export const DealPulseVehicleTitleStyle = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 700;
    margin-bottom: 4px;
`;

export const DealPulseEmphasisStyle = styled.span`
    font-weight: 700;
`;
